import axios from 'axios';
import errorUtility from './errorUtility';
import store from '../store/store'

export default {
    login,
    logout,
    getLoggedInUser,
    hasClaim,
    hasRole,
    getMemberId,
    getAuditorId
};

function login(emailAddress, password) {
    return axios
        .post('/api/Security/UserLogin', { emailAddress, password })
        .catch(e => Promise.reject(errorUtility.getErrorMessage(e)));
}

function logout() {
    return axios
        .post('/api/Security/UserLogout')
        .catch(e => Promise.reject(errorUtility.getErrorMessage(e)));
}


function getLoggedInUser() {
    return axios
        .get('/api/Security/CurrentUser')
        .then(response => {
            return response.data;
        })
        .catch(e => Promise.reject(errorUtility.getErrorMessage(e)));

}

function hasClaim(name, requiresWrite) {
    if (!store.state.authentication.user) {
        return false;
    }
    let claims = store.state.authentication.user.claims;
    return claims.some(claim => claim.name == name && (!requiresWrite || claim.value == "ReadWrite"));
}

function hasRole(name) {
    if (!store.state.authentication.user) {
        return false;
    }
    let roles = store.state.authentication.user.roles;
    return roles.some(role => role == name);
}

function getMemberId() {
    return store.state.authentication.user.memberId;
}

function getAuditorId() {
    return store.state.authentication.user.auditorId;
}
